export default "__VITE_ASSET__CWGa4C4e__"